import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { AlertConfirmService } from '../../services/alert-confirm.service';
import { DataService } from '../../services/data.service';

// import menuData from '../../json/menu-items.json';

declare var $: any;
// declare var bootstrap: any;

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent {
  items: any[] = [];
  menuItems: any = [];
  user: any = null;
    
  constructor(private alertService: AlertConfirmService, private router: Router, public dataService: DataService) {
    //
  }

  // ngOnChanges() {
  //   let my_modules = sessionStorage.getItem('my_modules');
  //   if(my_modules) {
  //     this.dataService.my_modules = JSON.parse(my_modules);
  //   }
  // }

  async ngOnInit() {
    let my_modules = sessionStorage.getItem('my_modules');
    if(my_modules) {
      this.dataService.my_modules = JSON.parse(my_modules);
    } else {
      this.dataService.my_modules = [];
    }

    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;

      if(this.user.user_role[0].code == 'spr') {
        this.menuItems = this.dataService.menuData.boxMenu_sa;
      } else {
        this.menuItems = this.dataService.menuData.boxMenu_adm;
      }
    }

    if(this.menuItems && this.menuItems.length) {
      for(let i=0; i<this.menuItems.length; i++) {
        const mmopt = this.dataService.getMainMenuItem(this.menuItems[i].mmid);
        if(mmopt) {
          // this.menuItems[i] = mmopt;
          this.menuItems[i].title = mmopt.title;
          this.menuItems[i].desc = mmopt.desc;
          this.menuItems[i].locked = false;

          if(this.user.user_name != 'sa' && this.user.user_name != 'mwcc') {
            if(this.dataService.my_modules && this.dataService.my_modules.length) {
              this.menuItems[i].locked = true;
            }
          }

          this.menuItems[i].passcode = mmopt.passcode;
          this.menuItems[i].hidden = mmopt.hidden;
          this.menuItems[i].sa_only = mmopt.sa_only;
          this.menuItems[i].optClick = mmopt.optClick;
          this.menuItems[i].for_module = mmopt.for_module;
          this.menuItems[i].component = mmopt.component;
          this.menuItems[i].icon = this.menuItems[i].ur_icon || mmopt.icon;
          this.menuItems[i].clrCode = this.menuItems[i].ur_clrCode || mmopt.clrCode;

          if(this.user.user_name != 'sa' && this.user.user_name != 'mwcc') {
            if(this.dataService.my_modules && this.dataService.my_modules.length) {
              const mm_code = mmopt.optClick;
              const retVal: boolean = this.dataService.my_modules.indexOf(mm_code) > -1 ? false : true;
              this.menuItems[i].locked = mmopt.for_module ? retVal : false;
            }
          }
        }
      }

      setTimeout(()=>{
        if (this.menuItems[0].locked && this.dataService.my_modules && this.dataService.my_modules.length) {
            location.reload();
        }
      }, 2000);
    }

  }

  menuClick(opt: any) {
    if(!opt.locked) {
      this.dataService.pgType = "";
      this.dataService.optMaxWin = true;

      if(opt.passcode) {
        this.openInputDialog(opt);
      } else {
        this.dataService.pgType = opt.optClick || "";
        this.router.navigate(['/dashboard/'+this.dataService.myEncrypt(this.dataService.pgType)]);
      }
    }
  }

  openInputDialog(opt: any) {
    this.alertService.confirm(
      'Protected Section',
      'Please enter passcode to open.',
      (value?: any) => {
        if(value == "000") {
          this.dataService.pgType = opt.optClick;
          this.router.navigate(['/dashboard/'+this.dataService.myEncrypt(this.dataService.pgType)]);
        }
      },
      () => {
        console.log('Cancelled');
      },
      'danger',
      {
        enabled: true,
        label: 'Pass Code:',
        placeholder: 'Passcode',
        type: 'password',
        required: false
      }
    );
  }

}